// Mirrors campaign_commons/schemas/enums/event.py — values must stay in sync with the backend
// Pydantic enums (payload keys are converted snake_case <-> camelCase by ApiInterceptor/CaseConverter
// automatically, but enum *values* are not touched by that conversion and must match exactly).

import { ECampaignDetailsTab } from '@pages/campaigns/campaign-details/campaign-details.interface';

export enum EEventType {
  campaignCreationStarted = 'campaign_creation_started',
  campaignCreationOpened = 'campaign_creation_opened',
  campaignCreationStepOpened = 'campaign_creation_step_opened',
  campaignCreationUpdated = 'campaign_creation_updated',
  campaignCreationFinished = 'campaign_creation_finished',
  campaignCreationDeliverableAdded = 'campaign_creation_deliverable_added',
  campaignCreationDeliverableRemoved = 'campaign_creation_deliverable_removed',
  campaignCreationDeliverableChanged = 'campaign_creation_deliverable_changed',
  campaignCreationDeliverableAddedSaved = 'campaign_creation_deliverable_added_saved',
  campaignCreationDeliverableRemovedSaved = 'campaign_creation_deliverable_removed_saved',
  campaignCreationDeliverableChangedSaved = 'campaign_creation_deliverable_changed_saved',
  campaignCreationDeliverableAdvancedSettingsChanged = 'campaign_creation_deliverable_advanced_settings_changed',
  campaignCreationExecutionAdded = 'campaign_creation_execution_added',
  campaignCreationExecutionRemoved = 'campaign_creation_execution_removed',
  campaignCreationExecutionChanged = 'campaign_creation_execution_changed',
  campaignCreationExecutionAddedSaved = 'campaign_creation_execution_added_saved',
  campaignCreationExecutionRemovedSaved = 'campaign_creation_execution_removed_saved',
  campaignCreationExecutionChangedSaved = 'campaign_creation_execution_changed_saved',
  campaignCreationKpiAdded = 'campaign_creation_kpi_added',
  campaignCreationKpiRemoved = 'campaign_creation_kpi_removed',
  campaignCreationKpiChanged = 'campaign_creation_kpi_changed',
  campaignCreationKpiAddedSaved = 'campaign_creation_kpi_added_saved',
  campaignCreationKpiRemovedSaved = 'campaign_creation_kpi_removed_saved',
  campaignCreationKpiChangedSaved = 'campaign_creation_kpi_changed_saved',
  campaignCreationGlobalGroupAdded = 'campaign_creation_global_group_added',
  campaignCreationCustomGroupAdded = 'campaign_creation_custom_group_added',
  campaignCreationGlobalGroupChanged = 'campaign_creation_global_group_changed',
  campaignCreationGlobalGroupRemoved = 'campaign_creation_global_group_removed',
  campaignCreationCustomGroupChanged = 'campaign_creation_custom_group_changed',
  campaignCreationCustomGroupRemoved = 'campaign_creation_custom_group_removed',
  campaignCreationGlobalGroupAddedSaved = 'campaign_creation_global_group_added_saved',
  campaignCreationGlobalGroupChangedSaved = 'campaign_creation_global_group_changed_saved',
  campaignCreationGlobalGroupRemovedSaved = 'campaign_creation_global_group_removed_saved',
  campaignCreationCustomGroupAddedSaved = 'campaign_creation_custom_group_added_saved',
  campaignCreationCustomGroupChangedSaved = 'campaign_creation_custom_group_changed_saved',
  campaignCreationCustomGroupRemovedSaved = 'campaign_creation_custom_group_removed_saved',
  campaignCreationGlobalBriefingNotesAdded = 'campaign_creation_global_briefing_notes_added',
  campaignCreationCustomBriefingNotesAdded = 'campaign_creation_custom_briefing_notes_added',
  campaignCreationGlobalBriefingNotesChanged = 'campaign_creation_global_briefing_notes_changed',
  campaignCreationGlobalBriefingNotesRemoved = 'campaign_creation_global_briefing_notes_removed',
  campaignCreationCustomBriefingNotesChanged = 'campaign_creation_custom_briefing_notes_changed',
  campaignCreationCustomBriefingNotesRemoved = 'campaign_creation_custom_briefing_notes_removed',
  campaignCreationGlobalBriefingNotesAddedSaved = 'campaign_creation_global_briefing_notes_added_saved',
  campaignCreationGlobalBriefingNotesChangedSaved = 'campaign_creation_global_briefing_notes_changed_saved',
  campaignCreationGlobalBriefingNotesRemovedSaved = 'campaign_creation_global_briefing_notes_removed_saved',
  campaignCreationCustomBriefingNotesAddedSaved = 'campaign_creation_custom_briefing_notes_added_saved',
  campaignCreationCustomBriefingNotesChangedSaved = 'campaign_creation_custom_briefing_notes_changed_saved',
  campaignCreationCustomBriefingNotesRemovedSaved = 'campaign_creation_custom_briefing_notes_removed_saved',
  campaignCreationClientCreated = 'campaign_creation_client_created',
  campaignCreationCreatorCreated = 'campaign_creation_creator_created',
  campaignAutomatedBriefingCreated = 'campaign_automated_briefing_created',
  campaignDeleted = 'campaign_deleted',
  campaignAnalyticsOpened = 'campaign_analytics_opened',
  campaignAnalyticsTabOpened = 'campaign_analytics_tab_opened',
  campaignAnalyticsScopeChanged = 'campaign_analytics_scope_changed',
  campaignAnalyticsGroupByContentChanged = 'campaign_analytics_group_by_content_changed',
  campaignAnalyticsFilterChanged = 'campaign_analytics_filter_changed',
  campaignAnalyticsViewModeChanged = 'campaign_analytics_view_mode_changed',
  campaignAnalyticsDeeplinkUsed = 'campaign_analytics_deeplink_used',
  campaignAnalyticsContentGroupExpanded = 'campaign_analytics_content_group_expanded',
  campaignAnalyticsContentGroupCollapsed = 'campaign_analytics_content_group_collapsed',
  campaignAnalyticsAllContentGroupsExpanded = 'campaign_analytics_all_content_groups_expanded',
  campaignAnalyticsAllContentGroupsCollapsed = 'campaign_analytics_all_content_groups_collapsed',
  campaignAnalyticsContentOpened = 'campaign_analytics_content_opened',
  campaignAnalyticsContentClosed = 'campaign_analytics_content_closed',
  campaignAnalyticsDeliverableOpened = 'campaign_analytics_deliverable_opened',
  campaignAnalyticsDeliverableClosed = 'campaign_analytics_deliverable_closed',
  campaignAnalyticsContentVideoPlayed = 'campaign_analytics_content_video_played',
  campaignAnalyticsExternalSourceOpened = 'campaign_analytics_external_source_opened',
  campaignAnalyticsFindingEntryClicked = 'campaign_analytics_finding_entry_clicked',
  campaignAnalyticsEvaluationContextSwitched = 'campaign_analytics_evaluation_context_switched',
  campaignAnalyticsAttachmentUploaded = 'campaign_analytics_attachment_uploaded',
  campaignAnalyticsAttachmentDeleted = 'campaign_analytics_attachment_deleted',
  campaignAnalyticsManualFindingStatusSet = 'campaign_analytics_manual_finding_status_set',
  campaignAnalyticsManualDeliverableStatusSet = 'campaign_analytics_manual_deliverable_status_set',
  campaignAnalyticsManualMatchingStatusSet = 'campaign_analytics_manual_matching_status_set',
  campaignAnalyticsInfoButtonHovered = 'campaign_analytics_info_button_hovered',
  campaignAnalyticsKpiPinned = 'campaign_analytics_kpi_pinned',
  campaignAnalyticsKpiUnpinned = 'campaign_analytics_kpi_unpinned',
  campaignManualBriefingCreated = 'campaign_manual_briefing_created',
  campaignBriefingDisabled = 'campaign_briefing_disabled',
  campaignBriefingUrlCopied = 'campaign_briefing_url_copied',
  campaignBriefingOpened = 'campaign_briefing_opened',
  campaignReportingViewOpened = 'campaign_reporting_view_opened',
  campaignReportCreated = 'campaign_report_created',
  campaignReportDeleted = 'campaign_report_deleted',
  campaignReportCloned = 'campaign_report_cloned',
  campaignReportUrlCopied = 'campaign_report_url_copied',
  campaignReportSaved = 'campaign_report_saved',
  campaignReportPublished = 'campaign_report_published',
  campaignReportUnpublished = 'campaign_report_unpublished',
  creatorCreated = 'creator_created',
  creatorTabOpened = 'creator_tab_opened',
  creatorContentOpened = 'creator_content_opened',
  creatorContentClosed = 'creator_content_closed',
  creatorContentVideoPlayed = 'creator_content_video_played',
  creatorExternalSourceOpened = 'creator_external_source_opened',
  creatorFilterChanged = 'creator_filter_changed',
  creatorChannelAdded = 'creator_channel_added',
  creatorRenamed = 'creator_renamed',
  creatorImageChanged = 'creator_image_changed',
  creatorChannelDeleted = 'creator_channel_deleted',
  creatorAuthenticationOpened = 'creator_authentication_opened',
  customerCreated = 'customer_created',
  customerDeleted = 'customer_deleted',
  globalTemplateCreated = 'global_template_created',
  teamMemberAdded = 'team_member_added',
  userNameChanged = 'user_name_changed',
  languageChanged = 'language_changed',
  accountLinked = 'account_linked',
  userInvitationSent = 'user_invitation_sent',
  userInvitationAccepted = 'user_invitation_accepted',
  mcpTeaserViewed = 'mcp_teaser_viewed',
  mcpTeaserDismissed = 'mcp_teaser_dismissed',
  mcpDialogOpened = 'mcp_dialog_opened',
  mcpDialogTabOpened = 'mcp_dialog_tab_opened',
  mcpDialogClosed = 'mcp_dialog_closed',
  mcpOpenInClaudeClicked = 'mcp_open_in_claude_clicked',
  mcpServerUrlCopied = 'mcp_server_url_copied',
}

export enum EEventViewMode {
  list = 'list',
  tiles = 'tiles',
  groupedByContent = 'grouped_by_content',
}

export enum EEventDeeplinkType {
  contentType = 'content_type',
  contentStatus = 'content_status',
  deliverable = 'deliverable',
  kpi = 'kpi',
}

// campaign_commons.schemas.enums.platform.PlatformFeature — exact backend string values (PascalCase).
// The existing EPlatformFeature (@enums/campaign.enum) uses different (camelCase) values, so event
// payloads must go through toEventPlatformFeature() (utilities/event-payload-mapping.util.ts) rather
// than sending EPlatformFeature values as-is.
export enum EEventPlatformFeature {
  twitchStream = 'TwitchStream',
  instagramPost = 'InstagramPost',
  instagramStory = 'InstagramStory',
  instagramReel = 'InstagramReel',
  youtubeVod = 'YoutubeVod',
  youtubeShort = 'YoutubeShort',
  youtubeStream = 'YoutubeStream',
  tiktokPost = 'TikTokPost',
  xPost = 'XPost',
  facebookPost = 'FacebookPost',
}

// campaign_commons' FrontendTab has no equivalent for ECampaignDetailsTab.creatorOverview/creatorTimeline
// (briefing-only pseudo-tabs). This narrowed type is what IAnalyticsEvent.previousTab/currentTab actually
// accept, so the compiler forces every call site through toEventFrontendTab() (event-payload-mapping.util.ts)
// instead of allowing those two values to be assigned directly.
export type TEventFrontendTab = Exclude<
  ECampaignDetailsTab,
  ECampaignDetailsTab.creatorOverview | ECampaignDetailsTab.creatorTimeline
>;
